import { render, staticRenderFns } from "./ContributionModalFooter.vue?vue&type=template&id=7b906165&"
import script from "./ContributionModalFooter.vue?vue&type=script&lang=js&"
export * from "./ContributionModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports